export default {
  // For all general Book Demo buttons. If you supply some other text in the component (on the page) it will overwrite this value.
  BOOK_DEMO_BUTTON_TEXT: 'Get Started Free',

  // The main title inside of the modal/popup that appears when you click on any of the Book Demo buttons.
  BOOK_DEMO2_MODAL_TITLE: 'Demo Request',

  // The main title inside of the modal/popup that appears when you click on any of the Book Demo buttons.
  BOOK_DEMO_MODAL_TITLE: 'Get Started Free',

  // Book demo button text in the navigation bar:
  BOOK_DEMO_NAVBAR_BUTTON_TEXT: 'Get Started',

  // For the bottom CTA area on pages like Dashboard, the section at the bottom of the page with the text and button:
  BOOK_DEMO_CTA_TITLE_TEXT: 'Get Started Free',
  BOOK_DEMO_CTA_DESCRIPTION_TEXT:
    'Join hundreds of immersive simulation experts by using Cognitive3D to understand your participants.',
  BOOK_DEMO_CTA_BUTTON_TEXT: 'Get Started Free',

  // For text content inside of "Book Demo" forms:
  BOOK_DEMO_FORM_TOP_PARAGRAPH:
    'Want to learn more about Cognitive3D? Send us an message below and we will reach out within one business day.',
  // For text content inside of "Book Demo" forms:
  BOOK_DEMO2_FORM_TOP_PARAGRAPH:
    'Meet with a 3D analytics expert and learn how you can get actionable insights from your project today.',

  // Front page hero call to action. This goes below the "CASE STUDY" links and above the "Trusted By" images.
  FRONT_PAGE_HERO_CTA_ENABLED: false,
  FRONT_PAGE_HERO_CTA_BUTTON_TEXT: 'GET ACCESS',
  FRONT_PAGE_HERO_CTA_HEADLINE: 'The Enterprise Guide to Scaling VR Training',
  FRONT_PAGE_HERO_CTA_URL:
    'https://resources.cognitive3d.com/enterprise-guide-scaling-vr-training/',

  // Base URL for newsletter signups.
  NEWSLETTER_URL:
    'https://cognitive3d.us12.list-manage.com/subscribe?u=b5a51541985fcedc556b0cb89&id=3bd0cb579a&EMAIL=',
  // This option adds the user's email to the end of the newsletter URL. If this is set to "false", then the user will have to input their email again in the next page
  NEWSLETTER_URL_APPEND_EMAIL: true,
  FORM_SUCCESSFUL_MSG: 'Your form was submitted successfully',
  FORM_SUCCESSFUL_ERROR: 'Unexpected Error. Please contact admin.',
  FORM_SUCCESSFUL_MSG_SIGNUP:
    'Your form was submitted successfully -> Check your email for registration instructions.',
}
